import { HttpClient } from "@angular/common/http";
import { effect, inject, Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { MessageCost, MessageDetails, MessageDraft, MessageDraftSend, StaffMessageDraft } from "../models/message";
import { UserStore } from "../stores/index";

@Injectable()
export class SharedMessageRepository implements OnDestroy
{
	private userType: string;
	private requestMapping: string = "messages";
	public ngDestroyed$: Subject<any> = new Subject();

	readonly userStore = inject(UserStore);

	public constructor(private http: HttpClient)
	{
		effect(() => {
			this.userType = this.userStore.type();
		})
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public getAvailableMessageCredits(): Observable<number>
	{
		return this.http.get<number>(`${this.requestMapping}/availableCredits`);
	}

	public getMessageDetails(messageId: string): Observable<MessageDetails>
	{
		return this.http.get<MessageDetails>(`${this.requestMapping}/${messageId}`);
	}

	public getMessageDraft(messageId: string): Observable<MessageDraft>
	{
		return this.http.get<MessageDraft>(`${this.requestMapping}/drafts/${messageId}`);
	}

	public getMessageCost(messageId: string): Observable<MessageCost>
	{
		return this.http.get<MessageCost>(`${this.requestMapping}/drafts/${messageId}/cost`);
	}

	public createMessageDraft(): any
	{
		const subject: Subject<Observable<MessageDraft>> = new Subject<Observable<MessageDraft>>();
		const draft: MessageDraft = new MessageDraft();
		if (this.userType === "CIVILIAN")
		{
			Radar.getLocation((err: any, result: any) =>
			{
				if (err)
				{
					Radar.ipGeocode((err2: any, result2: any) =>
					{
						if (err2)
						{
							subject.next(this.http.post<MessageDraft>(`${this.requestMapping}/drafts`, draft));
							subject.complete();
						}
						else
						{
							draft.latitude = result2.address.latitude;
							draft.longitude = result2.address.longitude;
							subject.next(this.http.post<MessageDraft>(`${this.requestMapping}/drafts`, draft));
							subject.complete();
						}
					});
				}
				else
				{
					draft.latitude = result.location.latitude;
					draft.longitude = result.location.longitude;
					subject.next(this.http.post<MessageDraft>(`${this.requestMapping}/drafts`, draft));
					subject.complete();
				}
			});
		}
		else
		{
			subject.next(this.http.post<MessageDraft>(`${this.requestMapping}/drafts`, draft));
			subject.complete();
		}
		return subject;
	}

	public createMessageDraftStaff(draft: StaffMessageDraft): any
	{
		return this.http.post<StaffMessageDraft>(`${this.requestMapping}/drafts`, draft);
	}

	public sendMessageDraft(messageDraftSend: MessageDraftSend): Observable<void>
	{
		return this.http.post<void>(`${this.requestMapping}/sent/${messageDraftSend.id}`, messageDraftSend);
	}

	public updateMessageDraft(messageDraft: MessageDraft): Observable<MessageDraft>
	{
		return this.http.put<MessageDraft>(`${this.requestMapping}/drafts`, messageDraft);
	}

	public markMessageSent(messageId: string): Observable<void>
	{
		return this.http.post<void>(`${this.requestMapping}/sent/${messageId}`, {});
	}

	public deleteDraft(messageId: string): Observable<void>
	{
		return this.http.delete<void>(`${this.requestMapping}/drafts/${messageId}`);
	}

	public deleteIncomingMessage(messageId: string): Observable<void>
	{
		return this.http.delete<void>(`${this.requestMapping}/inbox/${messageId}`);
	}

	public deleteSentMessage(messageId: string): Observable<void>
	{
		return this.http.delete<void>(`${this.requestMapping}/sent/${messageId}`);
	}
}
